import React, { useContext, useCallback } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import Group from 'components/utils/Group'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import MarkdownRender from 'LuxKit/MarkdownRender'
import ContactContext from 'contexts/contactContext'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface Props {
  termsAndConditions: string
  onViewOffers: () => void
}

function CruiseDealTermsConditionsModal({ termsAndConditions, onViewOffers }: Props) {
  const supportContact = useContext(ContactContext)
  const elementContext = useModalElementContext()

  const handleViewOffers = useCallback(() => {
    onViewOffers()
    elementContext?.resolve()
  }, [elementContext, onViewOffers])

  return <ModalBase size="L">
    <ModalHeader title="Terms and Conditions" />
    <ModalBody>
      <ModalContent>
        <BodyText variant="medium">
          <MarkdownRender content={termsAndConditions} />
        </BodyText>
      </ModalContent>
    </ModalBody>
    <ModalFooter>
      <Group
        direction="vertical-reverse"
        tabletDirection="horizontal"
        horizontalAlign="stretch"
        tabletHorizontalAlign="end"
        gap={16}
      >
        <TextButton
          kind="tertiary"
          size="large"
          startIcon={<LinePhoneIcon />}
          href={`tel:${supportContact.local.number}`}
          fit="mobile-full-width"
        >
          Call {supportContact.local.humanReadable}
        </TextButton>

        <TextButton
          kind="primary"
          size="large"
          onClick={handleViewOffers}
          fit="mobile-full-width"
        >
          View Offers
        </TextButton>
      </Group>
    </ModalFooter>
  </ModalBase>
}

export default CruiseDealTermsConditionsModal
